import letIngrate from "../imgs/lets_integrate.jpg";

export const sections = {
  V1: [
    { label: "Installation", key: "installation" },
    { label: "probable_use_cases", key: "probable_use" },
    { label: "examples", key: "examples" },
  ],
  V2: [
    { label: "React JS V1 One", key: "React_1" },
    { label: "React JS V2 Two", key: "React_2" },
  ],
};

export const payloadData = {
  installation: {
    Vanilla_JS: [
      {
        content: [
          { tag_type: "h1", text: "Peer to Admin - V1 - SDK quickstart." },
          { tag_type: "p", text: "Instant messaging enhances user engagement by enabling users to connect and form a community within the app. Increased engagement can lead to increased user satisfaction and loyalty to your app. An instant messaging feature can also provide real-time support to users, allowing them to get help and answers to their questions quickly. The Chat SDK enables you to embed real-time messaging in any app, on any device, anywhere." },
          { tag_type: "p", text: "This page guides you through implementing peer-to-adming messaging into your app using the Chat SDK for Web." },
          { tag_type: "p", text: "A User authentication system enhances close watch on users and better analytics of the users over the plateform." },
          { tag_type: "h2", text: "Integration of V1 (chat type)" },
          { tag_type: "img", src: letIngrate },

          { tag_type: "h2", text: "Prerequisites" },

          { tag_type: "p", text: "In order to follow the procedure on this page, you must have:" },

          {
            tag_type: "div",
            children: [
              {
                tag_type: "ul",
                items: [
                  {
                    textParts: [
                      { text: "Signup/Login", link: "https://qchat.example.com" },
                      { text: " to your account at Qchat Admin Page." }
                    ]
                  },
                  {
                    textParts: [
                      { text: "Create an App", link: "https://qchat.example.com" },
                      { text: "for your product." }
                    ]
                  },
                  {
                    textParts: [
                      { text: "Copy the " },
                      { text: "credentials", tag_type: "span", class: "highlighted-text" },
                      { text: ". We will require it soon during the integration." }
                    ]
                  }
                ]
              }
            ]
          },


          { tag_type: "h2", text: "Project setup" },

          { tag_type: "p", text: "To integrate Chat into your app, do the following:" },

          {
            tag_type: "div",
            children: [
              {
                tag_type: "ol",
                items: [
                  {
                    tag_type: "li",
                    text: "Get your credentials Handy; Find it the credentials section of the created App' Detail Page",
                  },

                  {
                    tag_type: "li",
                    text: "Update the script credentials section with your app's credentials",
                    sub_items: [
                      {
                        tag_type: "li",
                        text: "Find the entry file usually (index.html) and this below code in the head section of the html page.",
                        extra_text: "Update the script credentials section with your app's credentials",
                        code: '<script src="node_modules/chathead-consumer-client/dist/bundle.js"></script>'
                      },
                      {
                        tag_type: "li",
                        text: "after script is loaded we can initialize it like below.",
                        extra_text: "kindly add it below the first script",
                        code: `<script>\n\n   async function makeMeAPICall(token) {\n        const apiUrl = 'https://auth2.sageion.com/prod/me';\n\n        try {\n            const response = await fetch(apiUrl, {\n                method: 'GET',\n                headers: {\n                    'Authorization': token,\n                    'Accept': '*/*'\n                }\n            });\n\n            if (!response.ok) {\n                throw new Error('Network response was not ok');\n            }\n\n            const data = await response.json();\n            console.log('User me api data:', data.id);\n            return data;\n        } catch (error) {\n            console.error('There was a problem with the fetch operation:', error);\n            throw error;\n        }\n    }\n    \n    // Wait for the document to be fully loaded\n    document.addEventListener("DOMContentLoaded", async function() {\n\n        const token = localStorage.getItem('tezkit_token');\n        if (token){\n            var loggedInUser = await makeMeAPICall(token);\n            window.chathead.initialize(loggedInUser);\n        }\n        else{\n            window.chathead.setUp(app_name="app1_acm_true_tenant5", \n             api_key="dGVuYW50NV9fU0VQUkFUT1JfX2FwcDFfYWNtX3RydWVfdGVuYW50NQ==");\n            window.chathead.initialize(null);\n        }\n    });\n\n</script>`
                      },


                    ]
                  },
                  {
                    tag_type: "li",
                    text: "Verify if you see the header on the top of your page. like above",
                    img: letIngrate

                  },
                  {
                    tag_type: "li",
                    text: "Verify if you see the chat icon on the bottom of your page.",
                    img: letIngrate


                  },
                ]
              },


            ]
          },

          { tag_type: "h2", text: "Now visitors have become users" },
          {
            tag_type: "p", text: "which means we can keep close connection with them"
          },

          {
            tag_type: "div",
            children: [
              { tag_type: "h4", text: "Users now should be able to do the following" },
              {
                tag_type: "ul",
                items: [
                  { text: 'User can Signup / login' },
                  { text: 'User can send message to the Admin' },
                  { text: "User can receive message to the Admin" }
                ],
              }
            ]
          },

          { tag_type: "h3", text: "API reference" },
          {
            tag_type: "div",
            children: [
              {
                tag_type: "ul",
                items: [
                  {
                    tag_type: "li",
                    text: "makeMeAPICall",
                  },
                  {
                    tag_type: "li",
                    text: "window.chathead.initialize(<loggedInUser>)",
                  },
                  {
                    tag_type: "li",
                    text: "window.chathead.setUp(<app_name>, <api_key>)",
                  }
                ]
              },


            ],
          }
        ],
      },
    ],
    React_JS: [
      {
        content: [
          { tag_type: "h1", text: "Install it from REACT 3000source" },
          { tag_type: "p", text: "Additional content for Tab 2 of Child 1." },
        ],
      },
    ],
  },
  probable_use: {
    Vanilla_JS: [
      {
        content: [
          { tag_type: "h2", text: "Vanilla Js probable_use_cases" }
        ],
      },
    ],
    React_JS: [
      {
        content: [

          { tag_type: "p", text: "React Js probable_use_cases" },
        ],
      },
    ],
  },
  examples: {
    Vanilla_JS: [
      {
        content: [{ tag_type: "h3", text: "Vanilla Js examples" }],
      },
    ],
    React_JS: [
      {
        content: [
          { tag_type: "p", text: "React Js examples" },
        ],
      },
    ],
  },
  React_1: {
    Vanilla_JS: [
      {
        content: [
          { tag_type: "p", text: "React Tab 1" },
        ],
      },
    ],
    React_JS: [
      {
        content: [
          { tag_type: "p", text: "React Tab 2" },
        ],
      },
    ],
  },
  React_2: {
    Vanilla_JS: [
      {
        content: [
          { tag_type: "p", text: "React Tab 1." },
        ],
      },
    ],
    React_JS: [
      {
        content: [
          { tag_type: "p", text: "React Tab 2." },
        ],
      },
    ],
  },
};

